import {Component, ElementRef, OnInit, ViewChild, TemplateRef, Input} from '@angular/core';
import { GameService } from '../../../../shared/services/game/game.service';
//import { AppConfigService } from '../../../core/app.config.service';
import {
    AddressCombined,
    GameDetails,
    GameMessageType,
    GameModalMessage,
    GamePoints,
    SweepstakesWinner
} from '../../../../shared/constants/divisional.interface';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {properties} from '../../../../../environments/properties';
import { GAMETYPES } from 'src/app/shared/constants/constants';
import { CommonService } from 'abs-ngx-library/src/lib/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'games-grid',
    templateUrl: './game-grid.component.html',
    styleUrls: ['./game-grid.component.scss']
})
export class GameGridComponent implements OnInit {
    public gamesHeading: string = properties.gamesHeading;
    public gamesSub: string = properties.gamesSub;
    public programType: string = '';
    public programMinAge: number = properties.programMinAge;
    public programName: string = '';
    public optInStatus: boolean = false;
    public activeMode: string = "";
    public pageMode: string = "";
    public howItWorksNewUser: string = "";
    public howItWorksExistingUser: string = "";
    public sweepstakesHeadline: string = '';
    public sweepstakesCTA: string = '';
    public sweepstakesEntriesInfo: string = properties.sweepstakesEntriesInfo;
    public programData: any = null;
    public gameRewards: any;
    public emptyListMessage: string = '';
    public codes: string[] = null;
    public message: GameModalMessage = {
        mode: GameMessageType.INELIGIBLE,
        gameId: '',
        gameName: ''
    };
    public banner: string;
    public imagePath: string;
    public sm = '575px';
    public md = '768px';
    public sweepstakesWinners: SweepstakesWinner[];
    public programRulesLink: string = '';
    public programFAQLink: string = '';
    public programGameLink: string = '';
    public disclaimer: string = '';
    public showProgramCard: boolean = false;
    public showLoading: boolean = true;
    public tokenLabelSingular: string = '';
    public tokenLabelPlural: string = '';
    public gameModalMessageObserver: any = null;

    public aaisIntegrationEnabled: boolean = false;
    public currentPath: string = '';
    public currentParams: any = '';
    private currentEnvironment: string;
    private destroy$ = new Subject<void>();

    //SPA changes
    @Input() selectedGame: string;
    @Input() userInfo: any;
    @Input() singleCard: boolean = false;

    @ViewChild('invalidStore', { read: TemplateRef }) invalidStore: TemplateRef<any>;
    public invalidStoreRef: BsModalRef = null;

    @ViewChild('sweepstakesWinner', { read: TemplateRef }) sweepstakesWinner: TemplateRef<any>;
    public sweepstakesWinnerRef: BsModalRef = null;

    constructor(public elementRef: ElementRef, public gameService: GameService, public _commonService: CommonService, private modalService: BsModalService) {
    }

    gamesConfigHandler = (gameFlags) => {
        this.activeMode = gameFlags[this.banner]?.flags?.active;
        if(this.activeMode == properties.maintenance) {
            this.showProgramCard = true;
            this.showLoading = false;
        } else {
            this.gameService.getCustomerType(this.userInfo).subscribe(
                (response: AddressCombined) => {
                    this.userInfo.userType = response.customerType ? response.customerType : 'C';
                    this.getGamesInfo();
            }, (error) => { 
                this.userInfo.userType = 'C';
                this.getGamesInfo();
             });
        }
    }

    ngOnInit(): void {
        this.currentEnvironment = this.gameService.getEnvironment();
        this.imagePath = environment[this.currentEnvironment].imagePath;
        this._commonService._userInfoRefresh.subscribe(data => {
            if (data === 'initFunc') {
                this.banner = this.userInfo && this.userInfo.banner;
                this.activeMode = properties.dataActiveMode;
        
                this.gameService.getGamesConfigFlags().subscribe(data => {
                    if(data && data.gamesConfigFlags) {
                        this.gamesConfigHandler(data.gamesConfigFlags);
                    }
                });
                this.howItWorksNewUser = properties.howItWorksNewUser;
                this.howItWorksExistingUser = properties.howItWorksExistingUser;
                this.sweepstakesHeadline = properties.dataSweepstakesHeadline;
                this.sweepstakesCTA = properties.dataSweepstakesCta;
            }
        });

        this.gameService.refreshOptInStatusObservable.subscribe(data => {
            if (data) {
                this.getGamesInfo();
            }
        })
        this.gameService.refreshOptInStatusOnlyObservable.subscribe(data => {
            if (data) {
                this.optInStatus = true;
            }
        });
        
        this.gameModalMessageObserver = this.gameService.gameModalMessageObservable.subscribe(message => {
            // update fields based on message
            if (message.mode == GameMessageType.INELIGIBLE) {
                this.message = { ...message };
                this.modalService.onShown.subscribe(() => {
                    window['AB'].DIVISIONAL.modalTrapKeyboard(".invalid-store-modal");
                    let button = document.getElementById("invalid-store-close");
                    if (button) {
                        button.focus();
                    }
                });
                this.invalidStoreRef = this.modalService.show(this.invalidStore, { class: 'episodic-modal-dialog invalid-store-modal', ariaLabelledBy: 'invalid-store-headline'});
                this.analyticsModalTracking('not-available-at-this-store|view', 'view');
            }
            if (message.mode == GameMessageType.SHOWSWEEPSTAKES) {
                if (message.prizeDetail) {
                    let prize:SweepstakesWinner = {
                        prizeId: message.prizeDetail.prizeId,
                        prizeName: message.prizeDetail.name,
                        displayed: false,
                        drawDate: '',
                        winnerEmail: '',
                        expirationDate: '',
                        programCode: message.prizeDetail.programCode,
                        winningDetails: '',
                        deadlineDate: ''
                    }
                    this.sweepstakesWinners = [prize]
                    this.modalService.onShown.subscribe(() => {
                        window['AB'].DIVISIONAL.modalTrapKeyboard(".sweepstakes-winner-modal");
                        let button = document.getElementById("sweepstakes-winner-close");
                        if (button) {
                            button.focus();
                        }
                    });
                    this.sweepstakesWinnerRef = this.modalService.show(this.sweepstakesWinner, { class: 'episodic-modal-dialog sweepstakes-winner-modal', ariaLabelledBy: 'sweepstakes-winner-headline' });
                }
            }
        });


        this.gameService.refreshGamePointsObservable.subscribe(data => {
            // Game is loaded
            console.warn("refreshing points");
            const codes = this.gameService.getProgramCodes(this.programData || []);
            this.getGameRewardDetails(codes);
        })

        this.gameService.prizeRedeemedObservable.pipe(takeUntil(this.destroy$)).subscribe(obj => {
            this.singleCard = obj.singleCard;
            this.selectedGame = obj.selectedGame;
            const codes = this.gameService.getProgramCodes(this.programData || []);
            this.gameService.getProgramPoints(codes, this.userInfo).subscribe((res) => {
                this.gameRewards = res;
            this.programData = this.gameService.mergeProgramData(this.programData, this.gameRewards);

                if (this.gameRewards && this.gameRewards.programPoints && this.gameRewards.programPoints[0]) {
                    let gamePoints: GamePoints = {
                        totalGamePoints: this.gameRewards.programPoints[0].totalGamePoints,
                        totalPrizesWon: this.gameRewards.programPoints[0].totalPrizesWon
                    }
                    // send the updated points to the prize grid
                    this.gameService.gamePointsUpdated.next(gamePoints);
            }
        });
        })

    }

    getGamesInfo() {
        this.gameService.getPrograms(this.selectedGame, this.userInfo).subscribe((res: any) => {
            if (res === null) {
                res = [];
            }
            this.programData = res;
            this.aaisIntegrationEnabled = res.aaisIntegrationEnabled;
            if(this.programData.storePrograms && this.programData.userOptedInPrograms && !this.singleCard) {
                this.programData.storePrograms.length == 0 && this.programData.userOptedInPrograms.length == 0 ? this.showProgramCard = false : this.showProgramCard = true;
            } else {
                this.showProgramCard = true;
            }
            // No Games or Bonus Path sceanrio handling with {'gamesExist': this.showProgramCard} on api success ACIP-242310
            this.gameService.manageGamesInfo.next({'gamesExist': this.showProgramCard, programData: []});
            
            this.showLoading = false;
            this.codes = this.gameService.getProgramCodes(this.programData);
            this.sweepstakesWinners = res?.sweepstakesWinners || [];
            if(this.codes.length) {
                this.getSingleCardGamesInfo();
                this.getGameRewardDetails(this.codes);
            }

        }, (error) => {
            this.gameService.manageGamesInfo.next({'gamesExist': false, programData: []});
            this.showProgramCard = false;
            this.showLoading = false;
            this.programData = [];
            this.codes = [];
        });
    }

    getGameRewardDetails(codes: string[]) {
        
        this.gameService.getProgramPoints(codes, this.userInfo,).subscribe((res) => {
            this.gameRewards = res;
            this.programData = this.gameService.mergeProgramData(this.programData, this.gameRewards);
            if (this.singleCard) {
                if (this.gameRewards && this.gameRewards.programPoints && this.gameRewards.programPoints[0]) {
                    let gamePoints: GamePoints = {
                        totalGamePoints: this.gameRewards.programPoints[0].totalGamePoints,
                        totalPrizesWon: this.gameRewards.programPoints[0].totalPrizesWon
                    }
                    // send the updated points to the prize grid
                    this.gameService.gamePointsUpdated.next(gamePoints);
                }
                if (this.optInStatus) {
                    this.gameService.getSweepstakeWinner(codes[0], this.userInfo).subscribe(res => {
                        this.sweepstakesWinners = res;
                        if (this.sweepstakesWinners && this.sweepstakesWinners.length > 0) {
                            try {
                                const today = new Date();
                                const deadlineDate = new Date(this.sweepstakesWinners[0].deadlineDate)

                                if ( today <= deadlineDate && this.sweepstakesWinnerRef === null) {
                                    this.sweepstakesWinnerRef = this.modalService.show(this.sweepstakesWinner, { class: 'episodic-modal-dialog' });
                                }
                            } catch (e) {

                            }
                            
                        }
                    })
                }
            } else {

                if (this.sweepstakesWinners && this.sweepstakesWinners.length > 0) {
                    try {
                        const today = new Date();
                        const deadlineDate = new Date(this.sweepstakesWinners[0].deadlineDate)

                        if ( today <= deadlineDate && this.sweepstakesWinnerRef === null) {
                            this.sweepstakesWinnerRef = this.modalService.show(this.sweepstakesWinner, { class: 'episodic-modal-dialog' });
                        }
                    } catch (e) {

                    }
                }
            }
        });
    }

    getSingleCardGamesInfo() {
        if (this.singleCard && this.codes?.length == 1) {

            this.optInStatus = false;

            if (this.programData && this.programData.storePrograms && this.programData.storePrograms[0]) {

                const storeProgram = this.programData.storePrograms[0];

                if (storeProgram.optInStatus) {
                    this.optInStatus = storeProgram.optInStatus
                }

                if (storeProgram.name) {
                    this.programName = storeProgram.name;
                    this.sweepstakesEntriesInfo = this.sweepstakesEntriesInfo && this.sweepstakesEntriesInfo.replace(/{programName}/g, this.programName);
                }

                if (storeProgram.type) {
                    this.programType = storeProgram.type;
                }

                if (storeProgram.rulesurl) {
                    this.programRulesLink = storeProgram.rulesurl;
                }

                if (storeProgram.faqurl) {
                    this.programFAQLink = storeProgram.faqurl;
                }

                if (storeProgram.gameurl) {
                    this.programGameLink = storeProgram.gameurl;
                }

                if (storeProgram.disclaimer) {
                    this.disclaimer = storeProgram.disclaimer;

                     // fix up links in data from database
                    this.disclaimer = this.disclaimer.replace(/{faqLink}/g,`<a target='_blank' class='links__action links__action__inline underline' href='${this.programFAQLink}'>${this.programFAQLink}</a>`);
                    this.disclaimer = this.disclaimer.replace(/{rulesLink}/g,`<a target='_blank' class='links__action links__action__inline underline' href='${this.programRulesLink}'>${this.programRulesLink}</a>`);
                    this.disclaimer = this.disclaimer.replace(/{banner}/g,this.banner);
                }

                if (storeProgram.tokenLabelSingular) {
                    this.tokenLabelSingular = storeProgram.tokenLabelSingular;
                }

                if (storeProgram.tokenLabelPlural) {
                    this.tokenLabelPlural = storeProgram.tokenLabelPlural;
                }

                if(storeProgram.minAge) {
                    this.programMinAge = storeProgram.minAge;
                }
            }

            const today = new Date();
            
            //const endDate = this.programData && this.programData.storePrograms && this.programData?.storePrograms[0]?.endDate;
            const disableGamePlay = this.programData?.storePrograms[0]?.disableGamePlay;
            const gameType = this.programData?.storePrograms[0]?.type;
            let endDate = this.programData && this.programData.storePrograms && this.programData?.storePrograms[0]?.endDate;
            if (gameType === GAMETYPES.DIVISION && disableGamePlay) {
                endDate = this.programData?.storePrograms[0]?.postProgLiveDate;
            }
            if ( today <= endDate ) {
                this.showProgramCard = true;
                let jumpList = document.querySelector(".jump-list.hidden");
                if (jumpList) {
                    jumpList.classList.remove("hidden");
                }
                let details: GameDetails = {
                    codes: this.codes.join(','),
                    names: this.programName,
                    type: this.programType,
                    userOptedIn: this.optInStatus,
                    disclaimer: this.disclaimer,
                    tokenLabelSingular: this.tokenLabelSingular,
                    tokenLabelPlural: this.tokenLabelPlural,
                    programMinAge: this.programMinAge
                }

                if (this.programGameLink && this.programGameLink != '') {
                    details.gameLink = this.programGameLink;
                }

                if (this.programRulesLink && this.programRulesLink != '') {
                    details.rulesLink = this.programRulesLink;
                }

                if(gameType === GAMETYPES.DIVISION && disableGamePlay) {
                    details.disableGamePlay = disableGamePlay;
                }

                details.aaisIntegrationEnabled = this.aaisIntegrationEnabled;

                this.gameService.refreshGameDetails.next(details);

                // if (this.gameService.isAuthenticated(this.userInfo)) {
                //     this.gameService.refreshGamePoints.next(true);
                // }

            } else {

                let message: GameModalMessage = {
                    mode: GameMessageType.SHOWGAMESUMMARY,
                    gameId: this.codes.join(','),
                    gameName: this.programName
                }
                this.gameService.gameModalMessage.next(message);

            }
        } else {
            this.showProgramCard = true;
        }
    }

    public analyticsModalTracking(modalAction, event) {
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setGamesModalEvents(this.message?.gameId, modalAction, event);
            if (modalAction === 'not-available-at-this-store|view') {
                window['AB'].DATALAYER.gamesModalHandler(this.message?.gameId, 'not-available-at-this-store|close');
            }
        }
    }

    public getSweepstakesImgUrl(code: string, viewport?: string): string {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', code).replace('${viewport}', viewport) : '';
    }

    public getEmailId() {
        let res = '';
        if (this.sweepstakesWinners && this.sweepstakesWinners[0] && this.sweepstakesWinners[0].winnerEmail) {
            res = this.sweepstakesWinners[0].winnerEmail
        } else {
            if (window['AB'] && window['AB'].userInfo) {
                res = window['AB'].userInfo.email;
            }
        }
        return res;

    }
    public getIconImageUrl(code: string, viewport?: string): string {
        const imgPath = '-GC-icon?';
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}?$ecom-product-card-${viewport}-jpg$&', code + imgPath) : '';
    }

    public showStorePicker() {

        this.invalidStoreRef.hide();
        window['storeFulfillmentModal'].component.setModalDisplayData(3);
        this.analyticsModalTracking('not-available-at-this-store|change-stores-to-continue-playing', 'click');

    }

    public acknowledgeSweepstakesWin() {
        this.sweepstakesWinnerRef.hide();
        this.gameService.acknowledgeSweepstakesWin(this.sweepstakesWinners[0].prizeId, this.sweepstakesWinners[0].programCode, this.userInfo).subscribe(response => {
            // ignoring response for now
        }, error => {
            // ignoring error for now
        });


    }
    
    ngOnDestroy() {
        this.destroy$.next();  // This will trigger the unsubscription
        this.destroy$.complete();
        this.gameModalMessageObserver && this.gameModalMessageObserver.unsubscribe();
    }
}
